import React from 'react'

// Style sheet
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/aboutInformation.scss';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Watermark
import Watermark from '../../../../resources/image/watermark.jpg'

function AboutInformation() {
  return (
    <Container>
      <div id='aboutBox'>
        <Row>
          <Col xs={12} lg={9}>
            <div>
              <div className='aboutTextBox'>
                專業氣象是在2013年成立及開始運作，是脫胎於站長在中學求學時期的個人對氣象的興趣。
                當時為了擴張個人氣象預報及分析的影響力，因此成立專業氣象。
                專業氣象志在為香港市民提供更詳細及專業的天氣資訊，以期有助減低不同惡劣天氣對社會的影響。
                本站主要提供香港地區本地天氣分析及警報服務，並監察全球熱帶氣旋活動及提供相關分析。
                並輔以社交網絡及影音平台直播或影片發佈相關的分析及預報。
              </div>

              <div className='aboutTextBox'>
                本站所表示之氣象資料，包括但不限於香港地區的實測氣象數據、預報資料（數值預報及颱風路徑預報）、雷達及衛星圖像，
                均為相應資料之持有者（個人、組織及機構）所有。專業氣象並非該等資料的知識產權擁有人。
              </div>

              <div className='aboutTextBox'>
                <div>本站守則及責任聲明：</div>
                <div>1. 本站所發出的天氣資訊及警報屬非官方資訊，只供參考之用。官方天氣資訊及避難相關事宜，請參閱香港天文台等氣象機構及各地相關的政府機構。</div>
                <div>2. 本站並不負責任何人士、組織及機構因本站資訊所產生的問題及責任。</div>
                <div>3. 本站授權及歡迎任何人士、組織及機構，皆可在列明資料來源（即本站為資料來源）的情況下轉載由本站發出的所有內容。</div>
                <div>4. 本站各平台內所有並非來自本站的留言純屬留言者的個人意見，並不代表本站之立場。</div>
                <div>5. 如果你使用本站服務、閱覧或使用本站內容，即代表你已閱覧、明白並同意受此守則及責任聲明約束。本站保留向違反此守則及責任聲明之任何人士、組織及機構追究法律責任之權利。</div>
              </div>
            </div>
          </Col>
          <Col xs={{span: 12, order: 'first'}} lg={3}>
            <div className='aboutWatermark'>
              <img src={Watermark} alt='' width={'200px'}/>
            </div>
          </Col>

        </Row>




        
      </div>
      
    </Container>
    
  )
}

export default AboutInformation;